<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Review Calving
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('cows_wintered_assisted_calving') ? 'subsection-disabled' : ''">
          <u>% cows wintered that had assisted calving</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'cows_wintered_assisted_calving')">
            <span class="glyphicon" :class="isRemovedSubsection('cows_wintered_assisted_calving') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <bar :chart-data="chartData" :options="chartOptions" ref="cows_assisted_chart"></bar>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.calving_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.calving_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import Bar from '../../charts/Bar'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    Bar,
  },
  data() {
    return {
      stepName: 'ReviewCalving',
    }
  },
  computed: {
    chartOptions: function () {
      return {
        title: {
          display: false,
          text: '% cows wintered that had assisted calving'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Percent of CW'
            }
          }]
        }
      }
    },
    chartData: function () {
      return {
        labels: this.model.CHARTS.assisted_calvings.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.assisted_calvings.map(row => parseFloat((row['Percent Total Cows Wintered'] || '').replace('%', ''))).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.assisted_calvings.map(row => parseFloat((row['Region Avg. Percent Total Cows Wintered'] || '').replace('%', ''))).reverse(),
          },
        ],
      }
    },
  },
};
</script>

